import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import FormEmail from "./FormEmail";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import TableEmail from "./TableEmail";
import ButtonIcon from "../../../Buttons/ButtonIcon";
import { MdOutlineEmail } from "react-icons/md";
import ChatgptAssistantFom from "./ChatgptAssistantFom";
import AIChat from "./AIChat";

const Email = ({ eventDetails, token, userID, isLoading }) => {
  const [isEmailOpen, setIsEmailOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const canvasWidth = isMobile ? "100%" : 400;

  const key = ["allEmail", eventDetails?._id];
  const {
    data: getAllEmail,
    error: errorGetAllEmail,
    isLoading: isLoadingGetAllEmail,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}communication/email/${eventDetails?._id}`,
    token,
    {
      enabled: !!eventDetails?._id,
    }
  );

  const toggleEmail = () => {
    setIsEmailOpen(!isEmailOpen);
  };

  const toggleEChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  return (
    <div style={styles.container}>
      {/* Header Section */}
      <div style={styles.headerSection}>
        <h1 style={styles.mainTitle}>Email</h1>
        <p style={styles.subtitle}>
          Manage and track all your email communications. Send targeted emails
          to your attendees and monitor delivery status to stay connected.
        </p>
      </div>

      {/* New Email Button */}
      <div style={styles.buttonContainer}>
        <button
          onClick={toggleEmail}
          style={styles.newEmailButton}
          type="button"
        >
          <MdOutlineEmail size={isMobile ? 18 : 15} />
          <span>New Email</span>
        </button>
      </div>

      {/* Table Section */}
      <div style={styles.tableContainer}>
        <TableEmail
          myEmail={getAllEmail?.data}
        />
      </div>

      <OffCanvas
        isOffcanvasOpen={isEmailOpen}
        title="New Email"
        body={
          <FormEmail
            setIsSMSOpen={setIsEmailOpen}
            userId={userID}
            token={token}
            eventID={eventDetails?._id}
            eventDetails={eventDetails}
            isChatOpen={isChatOpen}
            setIsChatOpen={setIsChatOpen}
          />
        }
        toggleSaveChanges={toggleEmail}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <OffCanvas
        isOffcanvasOpen={isChatOpen}
        title="KagoBot"
        body={<AIChat />}
        toggleSaveChanges={toggleEChat}
        directionOffCanvas="start"
        widthOffCanvas={canvasWidth}
      />

      <style>{`
        @media (max-width: 768px) {
          .email-container {
            padding: 16px 12px !important;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 20px !important;
          }
          
          .subtitle {
            font-size: 13px !important;
          }
        }
      `}</style>
    </div>
  );
};

// Professional Styles
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    padding: "24px 20px",
    boxSizing: "border-box",
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
  },
  headerSection: {
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "2px solid #e9ecef",
  },
  mainTitle: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#111827",
    margin: "0 0 8px 0",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
    lineHeight: "1.6",
    maxWidth: "800px",
  },
  buttonContainer: {
    marginBottom: "24px",
  },
  newEmailButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "12px 24px",
    background: "linear-gradient(135deg, #f68a20 0%, #e57a10 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 12px rgba(246, 138, 32, 0.3)",
    height: "48px",
  },
  tableContainer: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    border: "1px solid #e5e7eb",
  },
};

export default Email;